import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import SalesCatering from "../../../assets/img/Featured/laptop-catering.png";
import IGOnDemand from "../../../assets/img/Featured/app-ondemand-food.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";

const OfficesAndConferencesPage = () => {
    const navigate = useNavigate();
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    return(
        <div className="page officesConferencesPage">
            <Header />
            <div className="page-header">Business & Industry Dining</div>
            <div className="text-wrapper">
                <div className="top">
                    <div className="topic-header">Offices & Conference Rooms</div>
                    <HorizontalLine />
                </div>
                <div className="std-text">
                    When it's hard to get away from the office for 
                    lunch, diners can order food and beverages with 
                    our mobile ordering solution and conveniently 
                    pick up their orders or have them delivered.{'\n\n'}
                </div>
                <div className="std-text">
                    Agilysys Sales & Catering will streamline 
                    managing your next meeting, making it easy to 
                    book your space and order food and beverages 
                    for your team.
                </div>

            </div>

            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Business & Industry Dining - Offices & Conference Rooms", "IG OnDemand");
                    addFlow("IG OnDemand");
                    navigate("/solutions/ig-on-demand")}}>
                    <img src={IGOnDemand} alt="" />
                    <div className="item-head">
                        <LogoMini />
                        IG OnDemand
                    </div>
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Business & Industry Dining - Offices & Conference Rooms", "Sales & Catering");
                    addFlow("Sales & Catering");
                    navigate("/solutions/sales")}}>
                    <img src={SalesCatering} alt="" />
                    <div className="item-head">
                        <LogoMini />
                        Sales & Catering
                    </div>
                </div>
            </FeaturedSolutions>
        </div>
    )
}
export default OfficesAndConferencesPage;